import {
  css, StyleSheet 
} from "aphrodite/no-important";
import PropTypes from "prop-types";
import React from "react";
import defaults from "../theme";
import {
  deepMerge 
} from "../utils/util";
import Icon from "./Icon";

function Header({
  customControls,
  onClose,
  showCloseBtn,
  closeBtnTitle,
  theme,
  count,
  currentIndex,
  ...props
}) {
  const classes = StyleSheet.create(deepMerge(defaultStyles, theme));

  return (
    <div className={css(classes.header)} {...props}>
      {customControls || <span />}
      <span className={css(classes.index)}>
        {currentIndex + 1}/{count}
      </span>
      {!!showCloseBtn && (
        <button
          title={closeBtnTitle}
          className={css(classes.close)}
          onClick={onClose}
        >
          <Icon
            fill={
              (!!theme.close && theme.close.fill) ||
                            defaults.close.fill
            }
            type='close'
          />
        </button>
      )}
    </div>
  );
}

Header.propTypes = {
  theme: PropTypes.object,
  customControls: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  showCloseBtn: PropTypes.bool,
  closeBtnTitle: PropTypes.string
};

const defaultStyles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: defaults.header.height,
    position: "absolute",
    top: 0
  },
  index: {
    padding: "10px 0",
    position: "absolute",
    top: "10px",
    left: "50%",
    transform: "translate(-50%， 0)"
  },
  close: {
    background: "#fff",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    outline: "none",
    position: "relative",
    top: 0,
    verticalAlign: "bottom",
    zIndex: 1,

    // increase hit area
    height: 40,
    marginRight: 12,
    marginTop: 12,
    padding: 8,
    width: 40
  }
};

export default Header;
